module.exports = __webpack_public_path__ + "letgo.8be1fabf.png";